import { t } from "@lingui/core/macro";
import { takeEvery } from 'typed-redux-saga';
import { addAssetTagsReset, contentLibraryAddAssetTagsComplete } from '../actions';
import { uploadTagsSelectors } from '../../../selectors';
import { put, select } from 'redux-saga/effects';
import { diContainer } from '@smartsheet/cufflink';
import { createToast } from '@integration-frontends/common/notifications';
import {
  ContentLibraryStateService,
  contentLibraryStateServiceDIKey,
} from '@smartsheet/content-library-state-service';

export function* handler() {
  const successfulAssetIds: string[] = yield select(uploadTagsSelectors.selectUploadTagsSuccess);

  if (successfulAssetIds.length > 0) {
    addSuccessfulAssetIdsToStateService(successfulAssetIds);
    yield put(
      createToast({
        id: `upload-tags-success-${crypto.randomUUID()}`,
        type: 'info',
        toastContent: {
          contentText: t`Tags added. It could take time for tags to show on all files.`,
        },
      }),
    );
  }

  yield put(addAssetTagsReset());
}

export function* contentLibraryAddAssetTagsCompleteEffects() {
  yield takeEvery(contentLibraryAddAssetTagsComplete, handler);
}

function addSuccessfulAssetIdsToStateService(assetIds: string[]) {
  const contentLibraryStateService = diContainer.get<ContentLibraryStateService>(
    contentLibraryStateServiceDIKey,
  );

  contentLibraryStateService.setBulkTaggedAssets(assetIds);
}
